import { render, staticRenderFns } from "./IconVoucherNumber.vue?vue&type=template&id=6090bf3b&"
import script from "./IconVoucherNumber.vue?vue&type=script&lang=js&"
export * from "./IconVoucherNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports